export default "__VITE_ASSET__996be0a4__"